import { createClient, OAuthStrategy } from '@wix/sdk';
import { members } from '@wix/members';
import { dataItems } from '@wix/data-items';

const canonicalOrigin = (
  process.env.REACT_APP_CANONICAL_APP_ORIGIN || 'https://platform.quantchecklabs.com'
).trim();

const extraAllowedOrigins = (process.env.REACT_APP_WIX_ALLOWED_ORIGINS || '')
  .split(',')
  .map((origin) => origin.trim())
  .filter(Boolean);

const allowedOrigins = Array.from(
  new Set([
    canonicalOrigin,
    // Keep this alias temporarily while edge redirects are in place.
    'https://www.platform.quantchecklabs.com',
    ...extraAllowedOrigins,
    process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : null,
    process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : null,
  ].filter(Boolean))
);

// Initialize the Wix SDK client with OAuth strategy
export const wixClient = createClient({
  modules: { members, dataItems },
  auth: OAuthStrategy({
    clientId: process.env.REACT_APP_WIX_CLIENT_ID,
    allowedOrigins,
  }),
});
